module.exports = __webpack_public_path__ + "img/location@2x.5538cce5.png";